import SuggestionsItem from './SuggestionsItem';
import { DISCOVER_PEOPLE_STATE } from '../constants';

interface FollowSuggestionsTypes {
  isLoadingDataSugggestFriends: boolean;
  dataGetSuggestFriends: any[];
  onFollow: (
    index: number,
    userId: number,
    followed: number,
    type: string,
  ) => void;
}

// FollowSuggestions Compoonent
// web legacy
// app\components\general\dumb\OnboardingPage\OnboardingStepThree\OnboardingStepThree.js
function FollowSuggestions({
  isLoadingDataSugggestFriends,
  dataGetSuggestFriends,
  onFollow,
}: FollowSuggestionsTypes) {
  const suggestionsResultStyle = {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  };
  const handleFollow = (index, user) => {
    const {
      user: { follow, userid },
    } = user;
    onFollow(index, follow, userid, DISCOVER_PEOPLE_STATE.SUGGEST);
  };

  return (
    <>
      {isLoadingDataSugggestFriends && (
        <p style={suggestionsResultStyle}>Loading</p>
      )}
      {dataGetSuggestFriends.length === 0 && (
        <p style={suggestionsResultStyle}>There is no suggestions available.</p>
      )}
      {dataGetSuggestFriends.length > 0 &&
        dataGetSuggestFriends.map((user, index) => (
          <SuggestionsItem
            index={index}
            key={user.user.userid}
            dataUserSuggestion={user}
            onFollow={() => handleFollow(index, user)}
          />
        ))}
    </>
  );
}

export default FollowSuggestions;
